import { render } from "./MoreHorizontal.vue?vue&type=template&id=5599fa9c&scoped=true"
import script from "./MoreHorizontal.vue?vue&type=script&lang=js"
export * from "./MoreHorizontal.vue?vue&type=script&lang=js"

import "./MoreHorizontal.vue?vue&type=style&index=0&id=5599fa9c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5599fa9c"

export default script